import { useAuthStore } from '../stores';
let redirectInProgress = false;
export function handleUnauthorizedRedirect() {
    if (redirectInProgress) {
        return;
    }
    redirectInProgress = true;
    useAuthStore.getState().logout();
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.assign('/login');
        return;
    }
    redirectInProgress = false;
}
